import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { Box, Button } from '@mui/material';
import StatusDialog from './StatusDialog';
import { useState } from 'react';
import { getConfigFile } from 'API/Config/api';
import { useEffect } from 'react';
import CategoryDialog from './ViewProduct/CategoryDialog';
import RemarksDialog from './ViewProduct/RemarksDialog';
import { GetBankIfscDetails, HandleUpdateStatusUserList } from 'API/UserList/CspList';
import BackdropLoader from '../../General/Loader';
import SnackBar from '../../General/SnackBar';





export default function AgentTable(props) {
  const [OpenStatus, setOpenStatus] = useState(false)
  const [ConfigFile, setConfigFile] = useState(null)
  const [UserProduct, setUserProduct] = useState(null)
  const [productId, setProductId] = useState(null)
  const [OpenEditDialog, setOpenEditDialog] = useState(false)
  const [UserId, setUserId] = useState(null)
  const [BankIfscDetails, setBankIfscDetails] = useState(null)
  const [IsLoading, setIsLoading] = useState(false)
  const [AlertOpen, setAlertOpen] = useState(false)
  const [AlertMessage, setAlertMessage] = useState(null)
  const [AlertType, setAlertType] = useState(null)
  const [OpenRemarksDialog, setOpenRemarksDialog] = useState(null)
  const [Remarks, setRemarks] = useState(null)
  const [AgentId, setAgentId] = useState(null)

  // const paginationModel = {  };

  const [Status, setStatus] = useState(null)


  const handleAlertOpen = (message, type) => {
    setAlertMessage(message)
    setAlertType(type)
    setAlertOpen(true)
  }


  const handleAlertClose = () => {
    setAlertOpen(false)
  }


  const handleChangeStatus = (event) => {
    setStatus(event.target.value)
  }

  const handleOpenRemarks = (row) => {
    setOpenRemarksDialog(true)
    setRemarks(row.row.activation_remarks)
  }

  const handleCloseRemarksDialog = () => {
    setOpenRemarksDialog(false)
  }

  const handleOpenEditDialog = () => {
    setOpenEditDialog(true)
  }

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false)
  }

  const handleStatusOpen = (row) => {
    setAgentId(row._id)
    setOpenStatus(true)
  }

  const handleStatusClose = () => {
    setOpenStatus(false)
    setStatus(null)
  }

  const handleFetchConfigFile = (row) => {
    console.log("row", row.row.product_id);
    setProductId(row.row.product_id)
    setUserId(row.row.user_id)
    getConfigFile(setConfigFile)
  }

  useEffect(() => {
    if (productId) {
      GetBankIfscDetails(productId, setBankIfscDetails)
    }
  }, [productId])

  useEffect(() => {
    if (productId && ConfigFile && Array.isArray(ConfigFile)) {
      let data = ConfigFile.find((item) => item._id === productId)
      setUserProduct(data)
      handleOpenEditDialog()
    }
  }, [ConfigFile])

  // console.log("ConfigFile",ConfigFile,UserProduct);

  console.log("porps", props);



  const columns = [
    { field: 'bank_name', headerName: 'Bank Name', width: 130, sortable: false },
    { field: 'application_id', headerName: 'Application ID', width: 130, sortable: false },
    {
      field: 'csp_code',
      headerName: 'CSP Code',
      width: 120,
      sortable: false
    },
    {
      field: 'agent_code',
      headerName: 'Agent Code',
      sortable: false,
      width: 150,
    },
    {
      field: 'agent_name',
      headerName: 'CSP Name',
      sortable: false,
      width: 200,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.row.agent_name}
        </div>
      ),
    },
    {
      field: 'district',
      headerName: 'District',
      sortable: false,
      width: 160,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.row.district}
        </div>
      ),
    },
    {
      field: 'state',
      headerName: 'State',
      sortable: false,
      width: 160,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.row.state}
        </div>
      ),
    },
    {
      field: 'ds_name',
      headerName: 'DS Name',
      sortable: false,
      width: 160,
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      sortable: false,
      width: 160,
      renderCell: (row) => (
        <Button size='small' onClick={() => handleOpenRemarks(row)}>view</Button>
      )
    },
    {
      field: 'csp_code_activation_date',
      headerName: 'Activation Date',
      sortable: false,
      width: 160,
    },
    {
      field: 'mobile_number',
      headerName: 'Mobile Number',
      sortable: false,
      width: 160,
    },
    {
      field: 'csp_code_status',
      headerName: 'Status',
      sortable: false,
      width: 200,
    },
    {
      field: 'view',
      headerName: 'View',
      sortable: false,
      width: 160,
      renderCell: (row) => (
        <Button size='small' onClick={() => handleFetchConfigFile(row)}>view</Button>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      sortable: false,
      width: 160,
      renderCell: (params) => (
        <Button size='small' disabled={params.row.backend_status === "Deleted" ? true : false} onClick={() => handleStatusOpen(params.row)}>Edit</Button>
      )
    },
  ];

  const handlePageChange = (newPage) => {
    props.handlePageChange(newPage)
  }

  const handleStatusChange = () => {
    if (!Status) {
      handleAlertOpen("Please select status", "error")
      return
    }
    else {
      const data = {
        agent_id: AgentId,
        csp_status: Status
      }
      HandleUpdateStatusUserList(data, setIsLoading, handleAlertOpen, handleStatusClose, props.handleGet)
    }

  }




  return (
    <Paper sx={{ height: 400, width: '100%' }}>
      <BackdropLoader open={IsLoading} />
      <SnackBar open={AlertOpen} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />
      <StatusDialog data={Status} handleChange={handleChangeStatus} open={OpenStatus} handleClose={handleStatusClose} handleSubmit={handleStatusChange} IsLoading={IsLoading} />
      <RemarksDialog open={OpenRemarksDialog} handleClose={handleCloseRemarksDialog} remarks={Remarks} />
      <CategoryDialog userId={UserId} open={OpenEditDialog} handleClose={handleCloseEditDialog} productData={UserProduct} ifsc_details={BankIfscDetails} />
      <Box
        sx={{
          '& .even-row': {
            backgroundColor: '#F6F6F6',
          },
          '& .odd-row': {
            backgroundColor: '#fff', // Light grey
          },
          '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#F8FAFC', // Header background color
          color: '#592375', // Header font color
          fontSize: '16px',
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-row:hover': {
           backgroundColor: 'unset !important', // Keeps the row color unchanged on hover
        },

          height:"100%"
        }}
      >
        <DataGrid
          rows={props.data ? props.data?.data?.data : []}
          columns={columns}
          paginationMode='server'
          rowCount={props.data ? props.data?.data.total_count : 0}
          
          disableRowSelectionOnClick
          disableColumnSorting
          disableColumnFilter
          // rowHeight={80}getRowClassName={(params) =>
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'
          }
          getRowId={(row) => row._id}
          initialState={{ pagination: { page: props.page, pageSize: 10 } }}
          paginationModel={{ page: props.page, pageSize: 10 }}
          onPaginationModelChange={handlePageChange}
          pageSizeOptions={[10]}
          sx={{ border: 0 }}
        />
      </Box>
    </Paper>
  );
}
